module.exports = __webpack_public_path__ + "static/media/bg-card-service-4.c5077d8b.gif";